import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import AdminModels from "./AdminModels";
import AdminProjects from "./AdminProjects";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AdminHome() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    checkAdminAuth();
  }, []);

  const checkAdminAuth = async () => {
    try {
      const session = await Auth.currentSession();
      const groups = session.getAccessToken().payload["cognito:groups"] || [];
      if (!groups.includes("llmasaservice-admin")) {
        navigate("/");
      }
    } catch (error) {
      console.error("Auth error:", error);
      navigate("/");
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Dashboard" />
          <Tab label="Models" />
          <Tab label="Projects" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        Dashboard Content
        
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AdminModels />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AdminProjects />
      </TabPanel>
    </Box>
  );
}
